import styled from "styled-components"
import { globalMixins } from "../../../assets/styles/styled-components"

const backgroundColorHandler = (color, themeColors) => {
  switch (color) {
    case "transparent":
      return `
      background: transparent;
      position: relative;
      z-index: 10;
    `
    case "transparent-dark":
      return `
      background: transparent;
      position: relative;
      z-index: 10;
    `
    case "dark":
      return `background: ${themeColors.darkGrey};`
    case "ivory":
      return `background: ${themeColors.ivory};
      border-bottom: 1px solid ${themeColors.ivoryShadow};`
    default:
      return ""
  }
}

export const StyledNotification = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 1;
  ${(props) =>
    props.variant === "blue" &&
    `
        background: linear-gradient(180deg, ${props.theme.colors.ctaLight} 0%, ${props.theme.colors.cta} 100%);
    `}
  ${(props) =>
    props.variant === "grey" &&
    `
        background: linear-gradient(180deg, ${props.theme.colors.darkGrey} 0%, ${props.theme.colors.black} 100%);
    `}
    @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    @keyframes slideIn {
      from {
        max-height: 0;
      }
      to {
        max-height: 50px;
      }
    }
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    @keyframes slideIn {
      from {
        max-height: 0;
      }
      to {
        max-height: 80px;
      }
    }
  }
  ${(props) =>
    props.display_notice
      ? `
        animation: slideIn .2s .6s both;
    `
      : `
        max-height: 0;
    `}
`
export const StyledNotificationDummy = styled.div`
  opacity: 0;
  padding: 16px;
`
export const StyledNotificationMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    flex-direction: column;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  ${(props) =>
    props.display_notice
      ? `
      animation: fadeIn .2s 1.2s both;
      `
      : `
      opacity: 0;
      `}

  & .button-v2 {
    min-height: 0;
    padding: 0;
    font-size: 14px;
    border-radius: 0;
    box-shadow: none;
    background: transparent;
    line-height: 18px;
    border: 0;
    position: initial;
    color: ${(props) => props.theme.colors.white};
    & .button-v2__icon {
      margin-left: 8px;
      @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
        margin-left: 8px;
      }
      & i {
        color: ${(props) => props.theme.colors.white};
        width: 14px;
        min-width: 14px;
        max-width: 14px;
        height: 14px;
        min-height: 14px;
        max-height: 14px;
        @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
          width: 12px;
          min-width: 12px;
          max-width: 12px;
          height: 12px;
          min-height: 12px;
          max-height: 12px;
        }
      }
    }
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
    }
    &:hover {
      box-shadow: none;
    }
  }
`
export const StyledNotificationText = styled.p`
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: ${(props) => props.theme.colors.white};

  & + .button-v2 {
    @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
      margin-left: 24px;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      margin-top: 8px;
    }
  }
`
export const StyledNotificationClose = styled.div`
  cursor: pointer;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    align-items: flex-start;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  ${(props) =>
    props.display_notice
      ? `
      animation: fadeIn .2s 1.2s both;
      `
      : `
      opacity: 0;
      `}

  & svg {
    color: ${(props) => props.theme.colors.white};
  }
`

export const StyledHeader = styled.header`
  ${(props) => backgroundColorHandler(props.background, props.theme.colors)}
  ${(props) =>
    props.isSticky &&
    `
    margin-bottom: ${props.headerHeight}px;
  `}
  z-index: 2;
  position: relative;
  /* ${(props) =>
    props.legacy &&
    (props.fixHeight
      ? `
        margin-bottom: -87px;
        @media (max-width: 1024px) {
          margin-bottom: -69px;
        }
      `
      : `
        margin-top: -87px;
        @media (max-width: 1024px) {
          margin-top: -69px;
        }
      `)} */
`
export const StyledHeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* ${(props) =>
    props.legacy
      ? `
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding-left: 4.8rem;
    padding-right: 4.8rem;
    @media (max-width: 1024px) {
      padding-left: 2.4rem;
      padding-right: 2.4rem;
    }
    @media (max-width: 500px) {
      padding-left: 1.6rem;
      padding-right: 1.6rem;
    }
    `
      : `
      ${globalMixins.container}
    `} */
  ${globalMixins.container}
  ${(props) =>
    props.full_bleed &&
    `
    align-items: flex-start;
  `}
`
export const StyledLogo = styled.a`
  padding: 16px 0;
  display: flex;
  cursor: pointer;
  width: auto;

  & img {
    ${(props) =>
      props.full_bleed
        ? `
        width: 160px;
        height: 89px;
      @media (max-width: ${props.theme.breakPoints.tablet}) {
        width: 120px;
        height: 67px;
      }
    `
        : `
            ${
              props.background === "ivory"
                ? `
            width: 120px;
            height: 67px;
            `
                : `
            width: 90px;
            height: 32px;
            `
            }
            
    `}
  }
`
export const StyledNav = styled.nav`
  display: flex;
  align-items: center;
  margin: 0 -16px;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin: 0 -8px;
  }
`
export const StyledNavItem = styled.a`
  font-family: ${(props) => props.theme.fonts.circularBook};
  font-size: 14px;
  padding: 16px;
  cursor: pointer;
  ${(props) =>
    props.background === "ivory" || props.background === "transparent-dark"
      ? `
        color: ${props.theme.colors.ivoryDark};
        `
      : `
        color: ${props.theme.colors.white80true}; 
             
        `}
  ${(props) =>
    props.mobileHide &&
    `
            @media (max-width: ${props.theme.breakPoints.tablet}) {
                display: none;
            }
        `}
`
export const StyledNavCta = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 16px 8px;
  }
  ${(props) =>
    props.secondaryBurger &&
    `
        ${
          props.isSticky
            ? `
            opacity: 1;
            transition: opacity .2s linear .2s;
            color: ${props.theme.colors.darkGrey};
            `
            : `
            opacity: 0;
            transition: opacity .2s linear 0s;
            `
        };
        display: none;
        @media (max-width: ${props.theme.breakPoints.tablet}) {
            display: flex;
        }
        `}
  & p {
    font-family: ${(props) => props.theme.fonts.circularBook};
    font-size: 14px;
    color: ${(props) =>
      props.background === "ivory" || props.background === "transparent-dark"
        ? ` ${props.theme.colors.ivoryDark}`
        : `${props.theme.colors.white80true}`};
    margin: 0;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      display: none;
    }
  }
  & i {
    margin: 0 0 0 8px;

    & svg {
      ${(props) =>
        props.background === "ivory" || props.background === "transparent-dark"
          ? `
                    color: ${props.theme.colors.ivoryDark}; 
                `
          : `
                    color: ${props.theme.colors.white}; 
                `}
    }
  }
`
